import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { User } from '../interfaces/user.interface';
import { SendUpdateSuscription } from '../interfaces/suscription.interface';
import { MessageChat, NoteRequest } from '../interfaces/userchatcrm';
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private baseApiSuscripciones = environment.baseApi + '/user';
  private chats = environment.baseApi + '/chats';
  private notes = environment.baseApi + '/notes';
  private baseApiCatalog = environment.baseApi + "/catalog";
  private usuarioCreado = new Subject<boolean>();


  constructor(private http: HttpClient) { }

  async getInfoCuenta(idUser: number, isCustomer: boolean): Promise<any> {
    return await this.http.get<any>(`${this.baseApiSuscripciones}/info/${idUser}/${isCustomer}`).toPromise();
  }

  updatePassword(idUser: number, body: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'text/plain' });
    return this.http.put<Response>(`${this.baseApiSuscripciones}/update-password/${idUser}`, body, { headers })
  }


  restetPassword( body: any, lang: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put<Response>(`${this.baseApiSuscripciones}/reset-password?lang=${lang}`, body, { headers })
  }

  usuariosXcliente(idCliente: number) {
    return this.http.get<any>(`${this.baseApiSuscripciones}/${idCliente}`).toPromise();
  }
  catalogoUsuarios(idDispositivo: number, idUsuarioActual: number | null) {
    return this.http.get<any>(`${this.baseApiCatalog}/${idDispositivo}/${idUsuarioActual}`).toPromise();
  }

  actualizarStatusUsuario(idUser: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { id: idUser };
    return this.http.put<any>(`${this.baseApiSuscripciones}/update-status/${idUser}`, body, { headers }).toPromise();
  }

  actualizarRolUsuario(idUser: number, idRol: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { id: idUser };
    return this.http.put<any>(`${this.baseApiSuscripciones}/update-rol/${idUser}/${idRol}`, body, { headers }).toPromise();
  }

  actualizarSuscripcion(body: SendUpdateSuscription) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put<any>(`${this.baseApiSuscripciones}/update-suscription`, body, { headers }).toPromise();
  }

  agregarUsuario(usuario: User, lang: string): Promise<any> {
    //const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(`${this.baseApiSuscripciones}/agregar?lang=${lang}`, usuario).toPromise();
  }

  mandarMensaje(idSuscription: number, idCustomer: number, mensaje: MessageChat) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(`${this.chats}/send/${idSuscription}/${idCustomer}`, mensaje, {headers}).toPromise();
  }

  crearNota(nota: NoteRequest) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(`${this.notes}/create`, nota, {headers}).toPromise();
  }

  changeUserMultiple(idSuscription: number, idUser: number | null | undefined, body: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put<Response>(`${this.chats}/change-user-multiple/${idSuscription}/${idUser}`,body, { headers })
  }

  setUsuarioCreado(){
    this.usuarioCreado.next(true);
  }
  eventoUsuarioCreado(){
    return this.usuarioCreado.asObservable();
  }

}
